export default {
  'Seja bem-vindo ao WeON': 'Welcome to WeON',
  'Esse campo é obrigatório': 'This field is required',
  'Login realizado com sucesso': 'Login successfully completed',
  search: 'Search',
  notfound: 'No Emoji Found',
  message_logoff: 'Are you leaving the system, do you really want to continue?',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  warning: 'Atenção',
  fieldsRequired: '',
  scriptNotFound: 'Não existe nenhum Script cadastrado para essa fila!',
  categories: {
    search: 'Search Results',
    recent: 'Frequently Used',
    people: 'Smileys & People',
    nature: 'Animals & Nature',
    foods: 'Food & Drink',
    activity: 'Activity',
    places: 'Travel & Places',
    objects: 'Objects',
    symbols: 'Symbols',
    flags: 'Flags',
    custom: 'Custom',
  },
  contact: 'Contact',
  pickpocketing: 'Pickpocketing',
  responsibleAgent: 'Responsible Agent',
  messageRegisteredSuccess: '{name} registered successfully!',
  messageContactInformationError:
    'An error occurred while retrieving contact data',
  messageUpdateContact: 'Contact edited successfully!',
  employerCodeDuplicated: 'ID already exists',
  messageAddTagSuccess: 'Tag added successfully!',
  messageErrorWhatsapp: 'No WhatsApp registered',
  messageErrorPhone: 'No registered phone',
};
